
export default {
    name: 'b-navbar-nav',
};
